import styled from 'styled-components';
import { theme } from './theme';

// Scoped styles wrapper - ONLY for NewHomePage component
// Contains only CSS variables - NO global element selectors
export const ScopedStyles = styled.div.attrs({
  className: 'custodiy-home-page-wrapper',
})`
  /* CSS Variables - scoped to this component only */
  // --custodiy-bg: ${theme.colors.bg};
  --custodiy-card: ${theme.colors.card};
  --custodiy-card2: ${theme.colors.card2};
  --custodiy-text: ${theme.colors.text};
  --custodiy-muted: ${theme.colors.muted};
  --custodiy-border: ${theme.colors.border};
  --custodiy-accent: ${theme.colors.accent};
  --custodiy-accent2: ${theme.colors.accent2};
  --custodiy-hdrOpacity: 0;
  --custodiy-heroY: 0px;
  --custodiy-heroOpacity: 1;

  /* Only base layout styles - NO global element styling */
  min-height: 100%;
  background: var(--custodiy-bg);
  font-family: ui-sans-serif, system-ui, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
`;

